export enum EONBOARDING_STATUS {
  START_ONBOARDING = "START_ONBOARDING",
  SETUP_SUPPLIERS = "SETUP_SUPPLIERS",
  SETUP_MULTI_ORGANIZATION_SUPPLIERS = "SETUP_MULTI_ORGANIZATION_SUPPLIERS",
  SHARE_INVOICE_EMAIL = "SHARE_INVOICE_EMAIL",
  ONBOARDED = "ONBOARDED",
  ESIGN_DOCUMENT_SIGNED = "ESIGN_DOCUMENT_SIGNED",
}
